import Loadable from 'react-loadable';
import Spinner from 'src/components/Spinner';

export default Loadable({
    loader: () => import('src/components/OverrideModal/createOverride'),
    loading: Spinner
});
